export type MenuItemDescription = {
    id?: string;
    label?: string;
    accelerator?: string;
    type?: "separator" | "submenu" | "checkbox" | "radio";
    enabled?: boolean;
    checked?: boolean;
    visible?: boolean;
    role?: string;
    tooltip?: string;
    icon?: string;
    submenu?: MenuItemDescription[] | null;
};

export default class MenuItem implements MenuItemDescription {
    id?: string;
    label?: string;
    accelerator?: string;
    type?: "separator" | "submenu" | "checkbox" | "radio";
    enabled?: boolean;
    checked?: boolean;
    visible?: boolean;
    role?: string;
    tooltip?: string;
    icon?: string;
    submenu?: MenuItem[] | null;

    constructor(opts: MenuItemDescription) {
        const {
            id,
            label,
            accelerator,
            type,
            enabled,
            checked,
            visible,
            role,
            tooltip,
            icon,
            submenu
        } = opts;

        this.id = id;
        this.label = label;
        this.accelerator = accelerator;
        this.type = type;
        this.enabled = enabled;
        this.checked = checked;
        this.visible = visible;
        this.role = role;
        this.tooltip = tooltip;
        this.icon = icon;
        this.submenu = submenu?.map(submenuItem => new MenuItem(submenuItem)) ?? null;
    }
}
